import React, { useState, useRef, useEffect } from 'react';
import DetectDevice from './DeviceDetector';
import { useMap } from 'react-leaflet/hooks';
import { IoIosClose, IoIosArrowForward, IoIosArrowBack } from 'react-icons/io';
import { BsInstagram, BsTwitter, BsTiktok } from 'react-icons/bs';
import '../styles/information.css';
import { isSafari } from 'react-device-detect';
import { useSelector } from 'react-redux';
import {
  IoIosAdd,
  IoIosRemove,
  IoIosArrowUp,
  IoIosArrowDown,
} from 'react-icons/io';
import '../styles/listview.css';
import token_dict from '../data/token_dict.json';
import ownership_full from '../data/availability_list.json';
import { Alchemy, Network } from 'alchemy-sdk';
import contract from './redux/config/config.json';
import { selectQueried } from './MyMap.js';
import polygonJson from '../data/geo_json_string.json';
import { useDispatch } from 'react-redux';
import { fetchData } from './redux/data/dataActions';
import BigNumber from "bignumber.js";
import Web3 from 'web3';

const contractABI = require('./contract-abi.json');
const tokenContractABI = require('./token-abi.json');
const storeABI = require('./store-abi.json');

const { createAlchemyWeb3 } = require('@alch/alchemy-web3');

var alch_network;
var alch_key;
var alchemyKey;
var contractAddress;
var tpx_address; 
var store_address;

if (contract.NETWORK.ID == 1) {
  // Initialization
  alch_key = contract.ALCH_KEY;
  alch_network = Network.ETH_MAINNET;
  alchemyKey = contract.ALCH_KEY_LINK;
  contractAddress = String(contract.CONTRACT_ADDRESS);
  tpx_address = String(contract.TPX_ADDRESS);
  store_address = String(contract.STORE_ADDRESS);
}
if (contract.NETWORK.ID == 5) {
  // Initialization
  alch_key = contract.ALCH_KEY_TEST;
  alch_network = "eth-sepolia"; //Network.ETH_SEPOLIA;
  alchemyKey = contract.ALCH_KEY_TEST_LINK;
  contractAddress = String(contract.CONTRACT_ADDRESS_GOERLI);
  tpx_address = String(contract.TPX_ADDRESS_GOERLI);
  store_address = String(contract.STORE_ADDRESS);
}

const alc_config = {
  apiKey: alch_key,
  network: alch_network,
};
const alchemy = new Alchemy(alc_config);
const alch_web3 = createAlchemyWeb3(alchemyKey);

export const Info_TPX_store = ({
  setProjectInfo,
  mintMessage,
  setMintMessage,
  setRevertMessage,
  DetectDevice,
}) => {
  //init state variables
  const blockchain = useSelector((state) => state.blockchain);
  const [items, setItems] = useState([]);
  const dispatch = useDispatch();
  const [CONFIG, SET_CONFIG] = useState({
    CONTRACT_ADDRESS: '',
    SCAN_LINK: '',
    NETWORK: {
      NAME: '',
      SYMBOL: '',
      ID: 0,
    },
    NFT_NAME: '',
    SYMBOL: '',
    MAX_SUPPLY: 1,
    WEI_COST: 0,
    DISPLAY_COST: 0,
    GAS_LIMIT: 0,
    MARKETPLACE: '',
    MARKETPLACE_LINK: '',
    SHOW_BACKGROUND: false,
  });

  // This is the color that fills notch space on mobile
  useEffect(() => {
    document.body.style.backgroundColor = 'white';
    return () => {
      document.body.style.backgroundColor = 'white';
    };
  });

  async function getApproval() {
    if(blockchain.account !== "" && blockchain.account !== null){
        window.contract = await new alch_web3.eth.Contract(
          tokenContractABI,
          tpx_address 
        );
        //console.log(window.contract,blockchain.account, store_address)   
        //const allowance = await window.contract.methods.allowance(blockchain.account, store_address).call();
        //console.log(allowance)   
        //if(allowance == 0){
          const value = BigNumber("115792089237316195423570985008687907853269984665640564039457584007913129639935");
          const gasEstimate = await window.contract.methods.approve(store_address, value).estimateGas({ from: blockchain.account });
          const transactionParameters = {
              gas: "0x" + String(Number(gasEstimate).toString(16)), //convert to right notation
              to: tpx_address, // Required except during contract publications.
              from: blockchain.account, // must match user's active address.
              'data': window.contract.methods.approve(store_address, value).encodeABI(), //make call to NFT smart contract 
          };
          try {
              const txHash = await window.ethereum
                  .request({
                      method: 'eth_sendTransaction',
                      params: [transactionParameters],
                  });
              return {
                  txn: txHash, 
                  success: true,
                  status: "✅ Check out your transaction on Etherscan: https://etherscan.io/tx/" + txHash
              }
          } catch (error) {
              setMintMessage('err');
              setRevertMessage(error.message);
              return {
                  success: false,
                  status: "😥 Something went wrong: " + error.message
              }
          }
        //}
    }
    else{
      setMintMessage('no_wallet');
      setRevertMessage(
        'Connect your ethereum wallet via the connect wallet dropdown before claiming'
      );
    }
  }

  async function executeMint(tokenId) {
    if(blockchain.account !== "" && blockchain.account !== null){
        window.contract = await new alch_web3.eth.Contract(
          storeABI,
          store_address 
        );
        const gasEstimate = await window.contract.methods.buyNFT(tokenId).estimateGas({ from: blockchain.account });
        const transactionParameters = {
            //gas: String(gasEstimate),
            //gasPrice: String(gasPrice),
            gas: "0x" + String(Number(gasEstimate).toString(16)), //convert to right notation
            to: store_address, // Required except during contract publications.
            from: blockchain.account, // must match user's active address.
            'data': window.contract.methods.buyNFT(tokenId).encodeABI(), //make call to NFT smart contract 
        };
        try {
            setMintMessage('minting');
            const txHash = await window.ethereum
                .request({
                    method: 'eth_sendTransaction',
                    params: [transactionParameters],
                });
            return {
                txn: txHash, 
                success: true,
                status: "✅ Check out your transaction on Etherscan: https://etherscan.io/tx/" + txHash
            }
        } catch (error) {
            setMintMessage('err');
            setRevertMessage(error.message);
            return {
                success: false,
                status: "😥 Something went wrong: " + error.message
            }
        }
    }
    else{
      setMintMessage('no_wallet');
      setRevertMessage(
        'Connect your ethereum wallet via the connect wallet dropdown before claiming'
      );
    }
  }

  //function to tpx. Alchemy used to estimate gas, then parameters are set for eth_sendTransaction.
  //eth_sendTransaction is then sent with whichever provder is connects. Likely metamask. 
  async function mintToken(tokenId) {
    if(blockchain.account !== "" && blockchain.account !== null){
        window.contract = await new alch_web3.eth.Contract(
          tokenContractABI,
          tpx_address 
        );
        //console.log(window.contract,blockchain.account, store_address)   
        const allowance = await window.contract.methods.allowance(blockchain.account, store_address).call();
        console.log(allowance)   
        if(allowance != 0){
          const result = executeMint(tokenId);
          return result;
        }else{
          try {
              const approved = await getApproval();
              const result = await executeMint(tokenId);
              return result;
          } catch (error) {
              console.error('Error occurred:', error);
          }
        }
    }
    else{
      setMintMessage('no_wallet');
      setRevertMessage(
        'Connect your ethereum wallet via the connect wallet dropdown before claiming'
      );
    }
  }

  const fetchImageFromTokenURI = async (tokenURI) => {
    try {
      const response = await fetch(`https://ipfs.io/ipfs/${tokenURI.slice(7)}`);
      const data = await response.json();

      // Assuming the JSON structure has an 'image' property
      const imageUrl = `https://ipfs.io/ipfs/${data.image.slice(7)}`;

      return imageUrl;
    } catch (error) {
      console.error('Error fetching or parsing JSON:', error);
      return null;
    }
  };

  async function getItems() {
    window.contract = await new alch_web3.eth.Contract(
      storeABI,
      store_address 
    );

    let avail_tokens = await window.contract.methods.tokenCounter().call();
    let newItems = [];
    for (let i = 0; i < avail_tokens; i++) {
      let tokenURI = await window.contract.methods.tokenURI(i).call();
      let tokenImage = await fetchImageFromTokenURI(tokenURI);
      let tokenCost = await window.contract.methods.tokenPrices(i).call();
      newItems.push({ 'tokenId': i, 'tokenURI': tokenImage, 'tokenCost': tokenCost });
    }
    console.log(newItems)
    setItems(newItems);
  }

  const getData = () => {
    if (blockchain.account !== '' && blockchain.smartContract !== null) {
      dispatch(fetchData(blockchain.account));
    }
  };
  const getConfig = async () => {
    SET_CONFIG(contract); 
  };

  useEffect(() => {
    getConfig();
    getItems();
  }, []);

  useEffect(() => {
    getData();
  }, [blockchain.account]);

  function formatNumberWithFixedDecimalsAndLocale(number, decimalPlaces = 2) {
    const fixedNumber = Number(number).toFixed(decimalPlaces);

    let [integerPart, decimalPart] = fixedNumber.split('.');

    integerPart = Number(integerPart).toLocaleString();

    return `${integerPart}.${decimalPart}`;
  }

  return (
      <>
      <div class="grid-container-claim-wrapper" style={{display: !DetectDevice ? "grid" : "block", 'grid-auto-flow': !DetectDevice ? "row" : "none", alignItems: "center", justifyContent: "space-around"}}>
      <h1
        style={{ marginTop: -10, fontSize: 56, color: 'white', fontFamily: 'Terminus', textAlign: "center" }}
      >
        {' '}
        Store{' '}
      </h1>
      {!DetectDevice ? (
      <>
      <div className="grid-container-TPX">
        {items.map((item, index) => (
          <div key={index} className="grid-item-TPX">
            <div className="grid-item-claim" style={{ alignItems: "center", justifyContent: "space-around", zIndex: "1" }}>
            <div className="TPX_card" style={{ position: "relative", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
              <img src={item.tokenURI} alt="Image" style={{ width: "200px", height: "200px", marginBottom: "10px" }} />
                <div className="claim-right" style={{ position: "absolute", padding: "5px", bottom: "0", right: "0", display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                  <div style={{ textAlign: "center", color: '#dcdcdc', fontStyle: 'normal', fontWeight: '700', letterSpacing: 'min(.1dvw,.1dvh)', fontSize: '22px', fontFamily: "Terminus" }}>
                    <span style={{ color: "#dcdcdc" }}>{Number(item.tokenCost).toFixed(2)} </span>TPX
                  </div>
                  <button className="tpx_claim_button" style={{ cursor: "pointer", fontStyle: "none", margin: "auto", marginTop: "3px", marginLeft: "10px" }}
                    onClick={(e) => {
                      //getApproval().then(response => {
                      mintToken(item.tokenId).then(response => {
                        if (response.success) {
                          console.log(response.txn);
                          // Use a loop to periodically check for the transaction receipt
                          const checkReceipt = setInterval(() => {
                            alch_web3.eth.getTransactionReceipt(response.txn, function (err, receipt) {
                              if (receipt) {
                                clearInterval(checkReceipt); // Stop checking once the receipt is found
                                console.log(receipt);
                                if (!err && receipt.status) { // Check if the transaction was successful
                                  console.log("Transaction successful");
                                  setMintMessage('claimedTPX');
                                  setRevertMessage(Number(0).toFixed(2));
                                } else {
                                  setMintMessage('err');
                                  setRevertMessage("transaction failed");
                                }
                              } else if (err) {
                                clearInterval(checkReceipt); // Stop checking if there's an error
                                console.error("Error fetching transaction receipt:", err.message);
                                setMintMessage('err');
                                setRevertMessage("transaction failed");
                              }
                            });
                          }, 2000); // Check every 2 seconds
                        } else {
                          console.error("An error occurred:", response.status);
                        }
                      }).catch((error) => {
                        console.error("An error occurred:", error.message);
                      });
                    //});
                    }}
                  >mint</button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      </>
      ) : null}
      </div>
      </>
  );
}

export default Info_TPX_store;
